import React from "react";



export default function VehicleIncidentDetail1() {
    return (
        <div className="vehicleincidentdatail-container my-4">
            {/* Header */}
            <div className="special-header panel-white-all">
            <h4 className="page-title">Vehicle Incident Details</h4>
            </div>

            {/* Table */}
            <div className="card col-md-12">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table  table-bordered mb-0">
                            <tbody>
                                <tr>

                                    <td style={{ width: "500px" }}>Vehicle Name</td>
                                    <td>Test Vehicle</td>

                                </tr>
                                <tr>

                                    <td>Driver</td>
                                    <td>Super Fast</td>

                                </tr>
                                <tr>

                                    <td>Location</td>
                                    <td>Pune</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Description</td>
                                    <td>Trip</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Expense</td>
                                    <td>$2000</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Date</td>
                                    <td>Mon Jul 8 2023</td>
                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
        </div>

    );

}